import { Pagination } from "@mantine/core";
import { Dispatch, useCallback } from "react";
import { HeldEmailQueueAction } from "../../../hooks/admin/useHeldEmailQueueState";

interface Props {
  page: number;
  total: number;
  dispatch: Dispatch<HeldEmailQueueAction>;
}

export function HeldEmailQueuePagination({ page, total, dispatch }: Props) {
  const handleChange = useCallback(
    (value: number) => dispatch({ type: "page", value }),
    [dispatch]
  );
  return total > 1 ? (
    <Pagination onChange={handleChange} total={total} value={page} />
  ) : null;
}
